import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS].GET_DONE_WORKS_ALL_HAND_MADE_WORKS]: {
    url: '/company/:companyId/done_works/all_hand_made_works/',
  }
}
